export const dropdownData = [
  { name: "Site type", num: 1, label: "Site type" },
  { name: "customertype", num: 2, label: "Customer type" },
  // { name: "projectzones", num: 3, label: "Project zone" },
];
